export default 'M3.173 4 12 10.194 20.556 4H3.173zM12 13.29 1 5.806V20h22V5.548L12 13.29z';